import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, delay, map, startWith, switchMap } from 'rxjs/operators';
import { AuthorizeService } from '../../api-authorization/authorize.service';
import { SharedNotificationService } from '../shared-notification.service';
import { ISupplier, SupplierSection, SupplierService } from '../supplier.service';
import { Role } from '../_models/role';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-regels-component',
    templateUrl: './regels.component.html',
    styleUrls: ['./regels.component.css']
})
export class RegelsComponent implements OnInit {
    matTabCacheLabel: string = 'userTabLocation';

    isAdmin: Observable<boolean>;

    control: FormControl = new FormControl('');
    suppliers: ISupplier[] = [];
    filteredSuppliers: Observable<ISupplier[]>;
    selectedEan: number;

    isLoadingRowResults: boolean = false;
    isLoadingSupplierResults: boolean = false;

    version: number = 0;

    @ViewChild(MatSort, { static: false }) sort: MatSort;
    selectedIndex?: number = null;

    constructor(
        private authorizeService: AuthorizeService,
        private _supplierService: SupplierService,
        private _notificationService: SharedNotificationService) {
        let activeTab = sessionStorage.getItem(this.matTabCacheLabel);
        if (activeTab != null) {
            this.selectedIndex = parseInt(activeTab);
        }
    }

    ngOnInit() {
        this.isAdmin = this.authorizeService.getUser().pipe(map(u => u && u.role && (u.role.includes(Role.Developer) || u.role.includes(Role.Administrator))));

        this.isAdmin.subscribe(data => data ? this.control.enable() : this.control.disable());

        this.filteredSuppliers = this.control.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );

        this._supplierService.getSuppliers(SupplierSection.regels).subscribe(data => {
            this.suppliers = data.items;

            var selectedSupplier = this.suppliers.find(function (element) {
                return element.selected;
            });
            if (selectedSupplier) {
                this.selectedEan = selectedSupplier.ean;
                this.control.patchValue(selectedSupplier.name);
            }
        });

        this._notificationService.isLoadingRowResultsObservable.subscribe({
            next: (x: boolean) => this.isLoadingRowResults = x,
            error: (err: Error) => console.error('Something went wrong setting isLoadingRowResult next value. Retrieved an error: ' + err)
        });
    }

    private _filter(value: string): ISupplier[] {
        if (!value) value = '';
        const filterValue = this._normalizeValue(value);
        return this.suppliers.filter(x => this._normalizeValue(x.name).includes(filterValue) || x.ean.toString() == filterValue);
    }

    private _normalizeValue(value: string): string {
        if (value == null || value == undefined || typeof value !== 'string') {
            value = '';
        }

        return value.toLowerCase().replace(/\s/g, '');
    }

    updateVersion() {
        this.version += 1;
    }

    onSupplierChange() {
        this._notificationService.setOnSupplierChange(this.selectedEan);
    }

    onTabChange(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;
        sessionStorage.setItem(this.matTabCacheLabel, this.selectedIndex.toString());
        this._notificationService.setOnTabChange();
    }

    onEnter(evt: any) {
        let supplierName = evt.source.value.name;

        const selectedSuppliers = this.suppliers.filter(supplier =>
            supplier.name.toLowerCase() == supplierName.toLowerCase());
        if (evt.source.selected && selectedSuppliers.length) {
            // check if more than one supplier found
            // if so, try to find based on EAN
            // https://dev.azure.com/mjkauto/PowerPlant/_workitems/edit/11343?src=WorkItemMention&src-action=artifact_link
            let selectedSupplier = selectedSuppliers.length == 1
                ? selectedSuppliers[0]
                : selectedSuppliers.find(supplier => supplier.ean == evt.source.value.ean);

            if (selectedSupplier) {
                this.selectedEan = selectedSupplier.ean;
                this.control.patchValue(selectedSupplier.name);
                this.onSupplierChange();
            }
        }
    }
}
